// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "watchparty-3db4b11bef83/scripts/" + chunkId + ".js";
};